import { fetchFooterSetting, FooterSetting } from 'features/footer/api';
import { useEffect } from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export interface FooterSettingAtom {
  loaded: boolean;
  setting: FooterSetting;
}

export const footerSettingAtom = atom<FooterSettingAtom>({
  key: 'footer-setting',
  default: {
    loaded: false,
    setting: {
      navis: []
    }
  }
});

/**
 * フッターに表示する内容を表示するための情報を取得するカスタムフック
 */
export const useSetFooterSetting = () => {
  const footerSetting = useRecoilValue(footerSettingAtom);
  const setFooterSetting = useSetRecoilState(footerSettingAtom);

  useEffect(() => {
    if (!footerSetting.loaded) {
      const fetchData = async () => {
        const response = await fetchFooterSetting();
        setFooterSetting({ loaded: true, setting: response });
      };

      fetchData();
    }
  }, [footerSetting.loaded, setFooterSetting]);
};
